'use strict';

import { useQuery } from '@tanstack/react-query';
import { fetchUserWishlist } from '@src/lib/api/homepageApi';

export const useUserWishlist = (userId) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ['user-wishlist', userId],
        queryFn: fetchUserWishlist,
        enabled: !!userId
    });

    return {
        wishlistItems: data?.items ?? [],
        isLoading: !!userId && isLoading,
        isError
    };
};
